import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21ca27aa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "not-found"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_divider = _resolveComponent("van-divider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_divider, {
    class: "title"
  }, {
    default: _withCtx(() => [_createTextVNode("抱歉，您訪問的頁面不存在")]),
    _: 1
  })]);
}